// extracted by mini-css-extract-plugin
module.exports = {"main":"header_main__D5UEf","left":"header_left__sNlRx","right":"header_right__0QQUE","h5":"header_h5__pucI8"};